import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const ChatFrame: React.FC<IProps> = (props) => {
	return (
		<svg
			width="274"
			height="107"
			viewBox="0 0 274 107"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 0C5.37258 0 0 5.37258 0 12V79C0 85.6274 5.37259 91 12 91H24.5527C23.541 96.9626 21.1149 103.711 19.1968 105.612C16.4233 108.362 43.7111 99.1048 54.14 91H262C268.627 91 274 85.6274 274 79V12C274 5.37258 268.627 0 262 0H12Z"
				fill="#0784A0"
			/>
		</svg>
	);
};

export default memo(ChatFrame);
